import {createAction} from '@reduxjs/toolkit'

export const asyncError = createAction('ASYNC_ERROR', (err: Error | string) => ({payload: err, error: true}))
